import { Middleware } from '@nuxt/types';

const redirects: Middleware = async (context) => {
  const { route } = context;

  if (!process.client) {
    return;
  }

  if (route.path === '/veidai/eurovizija/') {
    window.location.href = 'https://www.delfi.lt/eurovizija';

    return;
  }
};

export default redirects;
